<div class="df-dynamic-input-wrapper">
  <mat-form-field class="df-dynamic-input-field">
    <mat-label>{{ label }}</mat-label>
    <input
      #elementInput
      matInput
      [formControl]="control"
      [placeholder]="placeholder"
      [type]="type"
      [required]="required"
      [name]="name"
      [attr.min]="min"
      [attr.max]="max"
      [attr.minLength]="minLength"
      [attr.maxLength]="maxLength"
    />
    <mat-hint>{{ hint }}</mat-hint>
    <mat-error>
      <ng-template
        [ngTemplateOutlet]="errorMessageTemplate"
        [ngTemplateOutletContext]="{
          control: control,
          errors: control.errors
        }"
      ></ng-template>
    </mat-error>
  </mat-form-field>
</div>
